module.exports = __webpack_public_path__ + "img/logo0.832c11a8.png";